export enum SmsSendingStatus {
  NOT_SENDING,
  SENDING,
  SENT,
  FAILED,
  SEND_AGAIN
}
